import endpoints from 'api/endpoints';
import Immutable from 'immutable';

export default ({ version, lang, body }) => ({
  url: endpoints.putTermsUrl(version, lang),
  queryKey: `put${endpoints.putTermsUrl()}`,
  transform: response => response.data,
  transformResult: response => ({
    terms: response.data,
  }),
  body,
  force: true,
  meta: {
    authToken: true,
  },
  options: {
    headers: {
      Accept: 'application/json',
    },
    method: 'PUT',
  },
  update: {
    term: (prevEntities = Immutable.Map(), nextEntities) =>
      prevEntities.mergeDeep(nextEntities),
  }
});
